import React from 'react';

export default function HTML_Doctypes() {
  return (
    <div className="HTML_Doctypes">
      <h1>HTML Doctypes</h1>
      <p>This is the placeholder component for <strong>HTML Doctypes</strong>.</p>
      <p>Link: /html/reference/doctypes</p>
    </div>
  );
}
